import { render, staticRenderFns } from "./Warrant.vue?vue&type=template&id=3dc878f7"
import script from "./Warrant.vue?vue&type=script&lang=ts"
export * from "./Warrant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports